<template>
  <div id="app">
    <router-view/>
    <div v-show="$loading.isShow"
         :class="{'loader-overlay--white': $loading.isWhite}"
         class="loader-overlay">
      <Spinner size="large" message="Loading..."></Spinner>
    </div>
  </div>
</template>

<script>
import {AUTHORIZATION} from './constants/constants'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'App',
  async created () {
    this.$loading.show(true)
    await this.$store.dispatch('fetch', localStorage.getItem(AUTHORIZATION), {root: true})
      .then(status => {
        if (status !== 200) {
          this.$router.push('/login')
        }
        this.$loading.hide()
      })
  },
  components: {
    Spinner
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '../node_modules/@coreui/icons/css/coreui-icons.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '../node_modules/simple-line-icons/fonts/';
  @import '../node_modules/simple-line-icons/scss/simple-line-icons.scss';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '../node_modules/font-awesome/fonts/';
  @import '../node_modules/font-awesome/scss/font-awesome.scss';
  /* Import Bootstrap Vue Styles */
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  /* Import Vue Select Styles */
  @import '../node_modules/vue-select/src/scss/vue-select.scss';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue